/**
 * @file templateActions.js
 * @location src/store/reducers/templateActions.js
 * @role 반복 업무 템플릿 CRUD — ADD/EDIT/TOGGLE/DELETE_TEMPLATE
 *
 * 편집·삭제는 미래분만 영향 (이미 생성된 task 는 불변 — generateDueTasks 가 lastGenDate 로 분리).
 */
import { newId } from '../../utils/ids.js';

export const templateActions = {
  ADD_TEMPLATE: (state, action) => ({
    ...state,
    taskTemplates: [
      ...(state.taskTemplates ?? []),
      {
        ...action.template,
        // 시스템 필드는 payload 가 덮어쓰지 못하도록 뒤에 둔다 (createdAt/active/lastGenDate).
        // id 는 호출 측(Supabase 브리지)이 uuid 를 주면 그대로 사용 — 낙관적 row 와 서버 row 일치.
        id: action.template.id ?? newId('tmpl'),
        createdAt: new Date().toISOString(),
        active: true,
        lastGenDate: null,
      },
    ],
  }),
  EDIT_TEMPLATE: (state, action) => ({
    ...state,
    taskTemplates: (state.taskTemplates ?? []).map(t =>
      t.id === action.id ? { ...t, ...action.patch } : t),
  }),
  TOGGLE_TEMPLATE: (state, action) => ({
    ...state,
    taskTemplates: (state.taskTemplates ?? []).map(t =>
      t.id === action.id ? { ...t, active: !t.active } : t),
  }),
  DELETE_TEMPLATE: (state, action) => ({
    ...state,
    taskTemplates: (state.taskTemplates ?? []).filter(t => t.id !== action.id),
  }),
};
